<ng-container *ngIf="state$ | async as state">

  <!-- Progress loader overlay (absolute, sits above content) -->
  <div class="card__loader" *ngIf="state.showProgress">
    <img src="/assets/loaders/bloom_spinner.gif" alt="loader" />
    <p class="card__loader__text">Processing</p>
  </div>

  <!-- Content wrapper dimmed while in progress -->
  <div [ngClass]="{ dimmed: state.showProgress }">

    <!-- Evacuation & Drill forms -->
    <div class="emergency-evac" *ngIf="!state.isEvacMessageSent">

      <div class="emergency-evac__head">EMERGENCY EVACUATION</div>
      <div class="emergency-evac__desc">
        Automated messages and calls will be sent to
        <span class="emergency-evac__message">In-house</span> guests to
        immediately evacuate and to
        <span class="emergency-evac__message">Staff</span> to report to assigned areas.
      </div>

      <app-dynamic-form-landing
        #evacForm
        class="evac-reason"
        [formSections]="evacuationFormSections"
        [showButtons]="false"
        (fieldValueChanged)="onEvacFieldChanged()"
      ></app-dynamic-form-landing>

      <div *ngIf="state.showEvacError" class="error-message">
        *Minimum 4 characters are required.
      </div>

      <button
        [disabled]="!state.enableEvacButton"
        class="card__success__text__send emergency-evac__btn"
        (click)="sendEvacuation()"
      >
        <img
          class="card__success__text__send__image"
          [src]="!state.enableEvacButton
            ? '/assets/icons/action-dialog/iconDisabled.svg'
            : '/assets/icons/action-dialog/sidekickBtn.svg'"
          alt=""
        />
        <span>Emergency Evacuation</span>
      </button>

      <div class="seperator__condition">
        <div class="seperator__dashedTop"></div>
        <div>OR</div>
        <div class="seperator__dashedTop"></div>
      </div>

      <div class="emergency-evac__drill">EVACUATION DRILL</div>
      <div class="emergency-evac__desc">
        Guests and staff will be notified about the mock drill via messages and calls.
      </div>

      <app-dynamic-form-landing
        #drillForm
        class="drill-reason"
        [formSections]="drillFormSections"
        [showButtons]="false"
        (fieldValueChanged)="onDrillFieldChanged()"
      ></app-dynamic-form-landing>

      <div *ngIf="state.showDrillError" class="error-message">
        *Minimum 4 characters are required.
      </div>

      <button
        [disabled]="!state.enableDrillButton"
        class="card__success__text__send emergency-evac__drillBtn"
        (click)="sendDrill()"
      >
        <img
          class="card__success__text__send__image"
          [src]="!state.enableDrillButton
            ? '/assets/icons/action-dialog/iconDisabled.svg'
            : '/assets/icons/action-dialog/sidekickBtn.svg'"
          alt=""
        />
        <span>Evacuation Drill</span>
      </button>

    </div>

    <!-- Success message after notification sent -->
    <div class="emergency-evac emergency-evac__successText" *ngIf="state.isEvacMessageSent">
      <div
        class="emergency-evac__head"
        [ngClass]="{ 'emergency-evac__drillEvac': state.isDrillEvac }"
      >
        {{ state.isDrillEvac ? 'EVACUATION DRILL' : 'EMERGENCY EVACUATION' }}
        HAS BEEN SUCCESSFULLY TRIGGERED.
      </div>
      <div
        class="emergency-evac__head emergency-evac__messageArea"
        [ngClass]="{ 'emergency-evac__drillEvac': state.isDrillEvac }"
      >
        PLEASE REPORT TO THE ASSIGNED AREAS.
      </div>
    </div>

  </div>

</ng-container>
